module.exports = __webpack_public_path__ + "static/media/maintenance.921ef83d.png";